import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { Button } from "@twilio-paste/core/button";
import { useDispatch } from "react-redux";

import { sessionDataHandler } from "../sessionDataHandler";
import { changeEngagementPhase } from "../store/actions/genericActions";
import { EngagementPhase } from "../store/definitions";
import { containerStyles, textStyles, titleStyles } from "./styles/ConversationEnded.styles";

export const ConversationEnded = () => {
    const dispatch = useDispatch();
    const handleClick = () => {
        sessionDataHandler.clear();
        dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
    };

    return (
        <Box {...containerStyles}>
            <Text as="h3" {...titleStyles}>
                Obrigado por conversar com a gente!
            </Text>
            <Text as="p" {...textStyles}>
                Se você tiver mais alguma dúvida, sinta-se à vontade para entrar em contato novamente.
            </Text>
            <Button variant="primary" data-test="start-new-chat-button" onClick={handleClick}>
                Iniciar novo chat
            </Button>
        </Box>
    );
};
